export default __webpack_public_path__ + "locales/lv/People.json?hash=b58c6a77c982c91269f8060a7cf2105d";